import React from 'react';
import ProductTile from 'components/common/ProductTile';
import { Product } from 'utils/Product';

const ProductViewer = ({
  id, name, product,
}: {
  id: string, name: string, product: Product
}) => {
  return <div className='w-80'>
    <label htmlFor={id}>{name}</label>
    <span id={id}><ProductTile readonly product={product} /></span>
  </div>;
};

export default ProductViewer;
